<template>
    <div v-if="errorMessage" class="bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[650px] w-[90%] p-[20px] ">{{ errorMessage }}</div>
    <tr class="text-gray-600 flex relative text-sm bg-white border border-gray-400 p-[10px] w-full" v-for="newsDetail in props.news">
        <td class="items-center p-[5px] flex w-[25px]"><input type="checkbox" name="news-checkbox-{{ newsDetail.id }}" id="news-checkbox-{{ newsDetail.id }}"></td>
        <td class="items-center p-[5px] flex w-[25px]">{{ newsDetail.id }}</td>
        <td class="items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] flex ">
            <router-link :to="{ name: 'news', params: { id: newsDetail.id }}" class="hover:text-black hover:underline duration-300">{{ newsDetail.title }}</router-link>
        </td>
        <td class="items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] hidden  text-justify"> <div v-html="newsDetail.texte"></div></td>
        <td class="items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] flex "><img v-bind:src="newsDetail.image" class="w-full" alt=""></td>
        <td class="items-center md:w-[calc(100%/6)] w-[calc(100%/3)] overflow-x-auto p-[5px] md:flex hidden ">{{ newsDetail.date }}</td>
        <td class="items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] md:flex justify-center flex-wrap hidden ">
            <i class="fa-solid fa-trash-can bg-red-500 text-white p-[10px] rounded-[5px] mr-[5px] text-xl cursor-pointer" @click="confirmDelete(newsDetail)"></i>
            <i class="fa-solid fa-file-pen bg-blue-500 text-white p-[10px] rounded-[5px] ml-[5px] text-xl cursor-pointer" @click="confirmUpdate(newsDetail)"></i>
        </td>
    </tr>

    <div v-if="showConfirmationModal" class="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-800 bg-opacity-50">
        <div class="bg-white p-8 rounded-lg">
          <h2 class="text-lg font-bold mb-4">Confirmez la suppression du news</h2>
          <p>ID : {{ selectedNewsDetail?.id }}</p>
          <p>Titre : {{ selectedNewsDetail?.title }}</p>
          <div class="flex justify-end mt-6">
            <button class="px-4 py-2 bg-red-500 text-white rounded mr-4" @click="deleteNews">Supprimer</button>
            <button class="px-4 py-2 bg-gray-300 rounded" @click="cancelDelete">Annuler</button>
          </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import NewsDetail from '@/components/types/NewsDetail'
    import axios from 'axios';
    import { useRouter } from 'vue-router';
    const router = useRouter();
    import axiosInstance from '@/plugins/axios';
    
    const errorMessage = ref("");
    
    import { ref } from 'vue';
    const props = defineProps<{
        news: NewsDetail[],
    }>();


const showConfirmationModal = ref(false);
const selectedNewsDetail = ref<NewsDetail | null>(null);

const confirmDelete = (newsDetail: NewsDetail) => {
  selectedNewsDetail.value = newsDetail;
  showConfirmationModal.value = true;
};

const deleteNews = async () => {
  if (!selectedNewsDetail.value) return;

  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    const response = await axiosInstance.delete(`/news/${selectedNewsDetail.value.id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200 || response.status === 204) {
      window.location.reload();
    }
  } catch (error) {
    errorMessage.value = 'Erreur lors de la suppression du news: Vous n\'avez pas les autorisations requises';
    hideErrorMessageAfterDelay();
  } finally {
    selectedNewsDetail.value = null;
    showConfirmationModal.value = false;
  }
};

const confirmUpdate = (newsDetail: NewsDetail) => {
  selectedNewsDetail.value = newsDetail;
  router.push({ name: 'AddAnNewsWith', params: { id: newsDetail.id } });
};


const cancelDelete = () => {
  selectedNewsDetail.value = null;
  showConfirmationModal.value = false;
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};
    


</script>

<style>

</style>